<template>
  <div
    v-if="formGroup"
    class="form-group"
  >
    <label v-if="title">{{ title }}</label>
    <!--
      Вызывается при изменении значения.

      @event input
      @property {String} value Значение.
    -->
    <textarea
      class="form-control"
      :value="value"
      :rows="rowCount"
      :placeholder="placeholder"
      :disabled="disabled"
      :maxlength="maxLength"
      @input="$emit('input', $event.target.value)"
    />
  </div>
  <textarea
    v-else
    class="form-control"
    :value="value"
    :rows="rowCount"
    :placeholder="placeholder"
    :disabled="disabled"
    :maxlength="maxLength"
    @input="$emit('input', $event.target.value)"
  />
</template>

<script>

/**
 * Textarea.
 */
export default {
  name: 'CTextarea',
  props: {
    /**
     * Текущее значение.
     *
     * @model
     */
    value: {
      validator (value) {
        return ['string', 'number'].includes(typeof value) || value === null
      },
      required: true
    },
    /**
     * Обернуть ли textarea в div.form-group.
     */
    formGroup: {
      type: Boolean,
      default: false
    },
    /**
     * Текст для лейбла.
     */
    title: {
      type: String,
      default: ''
    },
    /**
     * Текст плейсхолдера.
     */
    placeholder: {
      type: String,
      default: ''
    },
    /**
     * Высота в строках текста.
     */
    rowCount: {
      type: Number,
      default: 3
    },
    /**
     * Возможно ли изменение значения.
     */
    disabled: {
      type: Boolean,
      default: false
    },
    /**
     * Максимальное количество символов значения.
     */
    maxLength: {
      type: Number,
      default: 255
    }
  }
}
</script>
